var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"font-size":"30px"}},[_c('div',{staticStyle:{"margin":"50px"}},[_vm._v("\n\t\t\t欢迎进入创优物流管理后台\n\t\t")])])}]

export { render, staticRenderFns }